import React from "react";
import { toast } from "sonner";
import { Receipt, FileText } from "lucide-react";
import { useAuth } from "../lib/auth";
import { FEE_DEFAULT } from "../lib/appDefaults";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Persistent receipt download bar shown after the user has paid. Pulls the
 * PDF from /api/payment/invoice using the stored JWT and triggers a download.
 */
export default function InvoiceBar({ user }) {
  const { config } = useAuth();
  if (user?.payment_status !== "paid") return null;

  const download = async () => {
    try {
      const res = await fetch(`${REACT_APP_BACKEND_URL}/api/payment/invoice`, {
        credentials: "include",
      });
      if (!res.ok) throw new Error("Could not load receipt");
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `IdeaThon_Receipt_${user?.invoice_no || "receipt"}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(err.message || "Could not download receipt");
    }
  };

  return (
    <div className="card-surface mt-6 flex flex-wrap items-center justify-between gap-3" data-testid="invoice-bar">
      <div className="flex items-center gap-3">
        <Receipt className="w-5 h-5 text-brand" strokeWidth={1.5} />
        <div>
          <div className="font-display text-sm text-white">Your registration receipt</div>
          <div className="text-xs text-gray-500 font-mono mt-0.5">
            {user?.invoice_no ? `#${user.invoice_no}` : "Generating…"} · GST not applicable · ₹{user?.amount_paid || config?.entry_fee || FEE_DEFAULT}
          </div>
        </div>
      </div>
      <button
        onClick={download}
        className="btn-secondary flex items-center gap-2 text-sm"
        data-testid="download-invoice-btn"
      >
        <FileText className="w-4 h-4" /> Download PDF
      </button>
    </div>
  );
}
